module.exports = __webpack_public_path__ + "img/shop-window.3a53005c.svg";